import { useEffect, useState } from 'react';

import { AutoEnableFullscreenSetting, MobilePhoneModeSetting, useSettingValue } from '~/routes/settings/settings-state';

export default function useFullscreenToggle({ remote = false } = {}) {
  const [, setAutoEnableFullscreen] = useSettingValue(AutoEnableFullscreenSetting);
  const [mobilePhoneMode] = useSettingValue(MobilePhoneModeSetting);
  // iPhone Safari has no Fullscreen API at all - `fullscreenElement` is undefined rather than null.
  const [isFullScreen, setIsFullScreen] = useState(!!document.fullscreenElement);
  // The remote mic is portrait whatever its settings say; the game turns landscape on a phone.
  const lockTo = remote ? 'portrait' : mobilePhoneMode ? 'landscape' : null;

  useEffect(() => {
    const onChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', onChange);

    return () => {
      document.removeEventListener('fullscreenchange', onChange);
    };
  }, []);

  const toggle = async () => {
    try {
      if (!document.fullscreenElement) {
        setAutoEnableFullscreen(true);
        await document.body.requestFullscreen();
        if (lockTo) {
          global.screen.orientation.unlock();
          await global.screen.orientation.lock?.(lockTo);
        }
      } else {
        setAutoEnableFullscreen(false);
        await document.exitFullscreen();
        if (lockTo) {
          global.screen.orientation.unlock();
        }
      }
    } catch (e) {
      console.info(e);
    }
  };

  return { isFullScreen, toggle, supported: document.fullscreenEnabled === true };
}
